import React, { useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { GigCardCarousel as GigCarousel } from '@fiverr-private/gig_listings';
import { Impression_Component } from '@fiverr-private/bianka_js';
import { CURRENCY_CODES } from '@fiverr-private/localization';
import type { GigListingsProps } from '../../types';
import { enrichContext } from '../../utils/enrichContext';
import ListingsImpressionContainer from '../ListingsImpressionContainer';
import { onGigCardImpression } from '../ListingsImpressionContainer/utils';
import { EventReportingManagerContext } from '../../../../../../components/EventReportingManager';
import { useEditorAsyncProps } from '../../hooks/useEditorAsyncProps';

const COMPONENT_NAME = 'GigCardCarousel';

type GigCardCarouselProps = GigListingsProps & {
    sliderBaseNum?: number;
};

const GigCardCarousel = (props: GigCardCarouselProps) => {
    const [gigs, setGigs] = useState(props?.gigs || []);
    const { carousel_name, currencyObject } = props;
    const { enabled: reportingEnabled } = useContext(EventReportingManagerContext);
    const editorAsyncProps: Record<string, any> = useEditorAsyncProps(COMPONENT_NAME);

    useEffect(() => {
        if (!isEmpty(editorAsyncProps?.gigs)) {
            setGigs(editorAsyncProps.gigs);
        }
    }, [editorAsyncProps]);

    return (
        <ListingsImpressionContainer listingsProps={props}>
            <GigCarousel
                features={{ useForcePriceRounding: currencyObject?.name !== CURRENCY_CODES.USD, priceFormatting: true }}
                isLoading={!gigs.length}
                context={enrichContext({ carousel_name, currencyObject })}
                gigs={gigs}
                showTranslatedUGC
                isExperiential
                onImpression={(impressionData: Impression_Component) =>
                    reportingEnabled && onGigCardImpression(impressionData, props)
                }
                sliderBaseNum={props.sliderBaseNum}
            />
        </ListingsImpressionContainer>
    );
};

export default GigCardCarousel;
